import { IonButton, IonButtons, IonCheckbox, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, isPlatform } from '@ionic/react';
import { arrowBack, openOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { marcaLojasCarregar, requestService, usuarioCadastrar } from '../../../Utils/Services';
import './Cadastro.css';

const Cadastro: React.FC = () => {

  const validator = require('validator');
  const TAB_KEY_CODE = 9;
  const ENTER_KEY_CODE = 13;
  const history = useHistory();
  const campoTelefone = useRef<any>(null);
  const [nome, setNome] = useState("");
  // const [cpf, setCPF] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [checked, setChecked] = useState(false);
  const [checked90diasGratis, setChecked90diasGratis] = useState(true);


  const [lojas, setLojas] = useState<any>([]);
  const [loja, setLoja] = useState<any>("");
  const [chamarServicoMarca, setChamarServicoMarca] = useState(false);
  const [showLojas, setShowLojas] = useState(false);

  // const [documento, setDocumento] = useState("");
  // const [isEstrangeiro, setIsEstrangeiro] = useState(false);
  // const localStorageIsEstrangeiro = localStorage.getItem("estrangeiro") === "true";

  const cadastrar = () => {

    let validadorCelular = /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/;

    if (nome.length < 3 || telefone.length != 15 || email.length < 3) {
      setTextToast("Todos os campos são obrigatórios.");
      setShowToast(true);
    }
    else if (lojas.length > 1 && loja == "") {
      setTextToast("Selecione uma loja.");
      setShowToast(true);
    }
    else if (checked == false) {
      setTextToast("Você precisa aceitar os termos de uso e política de privacidade para efetuar o cadastro.");
      setShowToast(true);
    }
    else if (checked90diasGratis == false) {
      setTextToast("Você precisa aceitar os 90 dias grátis para efetuar o cadastro.");
      setShowToast(true);
    }
    else {


      // if (!isEstrangeiro) {
      //   // Validação de CPF (não estrangeiro)
      //   if (cpf.length !== 14) {
      //     setTextToast("CPF é obrigatório.");
      //     setShowToast(true);
      //     return;
      //   } else if (!validarCpfNovo(cpf)) {
      //     setTextToast("CPF Inválido.");
      //     setShowToast(true);
      //     return;
      //   }
      //   } else {
      //     if (documento.length !== 11) {
      //       setTextToast("Documento é obrigatório.");
      //       setShowToast(true);
      //       return;
      //     }
      // }

      // Validação de telefone (independente de estrangeiro ou não)
      if (!validadorCelular.test(telefone)) {
        setTextToast("Celular Inválido.");
        setShowToast(true);
      }


      // Validação do telefone (independente do status de estrangeiro)
      else if (!validadorCelular.test(telefone)) {
        setTextToast("Celular Inválido.");
        setShowToast(true);
      }

      else if (!validator.isEmail(email)) {
        setTextToast("E-mail Inválido.");
        setShowToast(true);
      }
      else {

        const telefoneFormatado = "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "");

        const objectRequest = {
          nome: nome,
          cpf: telefoneFormatado, //!isEstrangeiro ? cpf.replace("-", "").replace(".", "").replace(".", "") : documento.padStart(11, '0'),
          telefone: telefoneFormatado,
          email: email,
          loja: loja,
          dispositivoIos: isPlatform('ios')
        }
        requestService(
          usuarioCadastrar.url,
          {
            method: usuarioCadastrar.method,
            headers: [
              ["token", window.localStorage.getItem("token") || ""]
            ],
            body: JSON.stringify(objectRequest),
            credentials: 'include'
          },
          history,
          (response: any) => {
            console.log(response);
            if (response) {
              // window.localStorage.setItem("cpf", objectRequest.cpf);
              window.localStorage.setItem("telefone", objectRequest.telefone);
              window.localStorage.setItem("token", "token=" + response.token);
              window.localStorage.setItem("nome", nome);
              // Geolocation.getCurrentPosition().then(
              //   (result) => {              
              //     window.localStorage.setItem("latitude", result.coords.latitude.toString());
              //     window.localStorage.setItem("longitude", result.coords.longitude.toString());
              //   }
              // );
              //history.replace("/validar-celular");
              history.push("/validar-celular");
            } else if (response.status === 400) {

            }
          },
          (error: any) => {
            console.log(error);
            setTextToast("Cadastro já existente");
            setShowToast(true);
          }
        )
      }
    }
  }

  // function onChangeCPF(e: any) {

  //   //console.log(cpf.length);
  //   //console.log(e.target.value.length);
  //   e.persist();
  //   e.preventDefault();

  //   // if (e.keyCode === ENTER_KEY_CODE || e.keyCode === TAB_KEY_CODE) {
  //   //   e.target.value = e.target.value.substring(0, 14);
  //   //   setCPF(e.target.value.substring(0, 14));
  //   //   campoTelefone.current.setFocus();
  //   // }

  //   if (e.target.value.length > 14) {
  //     e.target.value = e.target.value.substring(0, 14);
  //     setCPF(e.target.value.substring(0, 14));
  //     return;
  //   }

  //   let val = e.target.value;
  //   var cpfval = val.replace(/\D/g, "")
  //   cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
  //   cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
  //   cpfval = cpfval.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  //   console.log(cpfval);
  //   setCPF(cpfval);
  // }

  function onKeyUpTelefone(e: any) {

    e.persist();
    e.preventDefault();

    // if (e.keyCode === ENTER_KEY_CODE) {
    //   e.target.value = e.target.value.substring(0, 15);
    //   setTelefone(e.target.value.substring(0, 15));
    //   cadastrar();
    // }

    if (e.target.value.length > 15) {
      e.target.value = e.target.value.substring(0, 15);
      setTelefone(e.target.value.substring(0, 15));
      return;
    }

    console.log(telefone.length);
    console.log(e.target.value.length);

    let replaceAt = function (str: any, index: any, replacement: any) {
      return str.substr(0, index) + replacement + str.substr(index + replacement.length);
    }

    let form = "(__) _____-____";

    let val = e.target.value;

    let i = 1;
    if (telefone.length > 0) {
      i = 0;
    }
    let j = 0;
    let aumentou = false;

    if (val.length > telefone.length) {

      for (; i < form.length; i++) {
        if (j < val.length) {

          form = replaceAt(form, i, val.charAt(j))

          if (form.charAt(i + 1) === '(' || form.charAt(i + 1) === ')' || form.charAt(i + 1) === '-') {
            if (val.charAt(j + 1) !== form.charAt(i + 1)) {
              if (form.charAt(i + 1) === ')') {
                i++;
              }
              i++;
              aumentou = true;
              j++;
            } else {
              j++
            }
          } else {
            j++;
          }
        } else {
          break;
        }
      }
    } else {
      if (telefone.length === 1 || telefone.length === 11) {
        form = val.substr(0, val.length - 1);
      } else if (telefone.length === 5) {
        form = val.substr(0, val.length - 2);
      } else {
        form = val;
      }
      i = form.length;
    }
    setTelefone(form.substr(0, i));
  }


  function validarCpfNovo(val: any): boolean {
    if (val.length == 14) {
      var cpf = val.trim();

      cpf = cpf.replace(/\./g, '');
      cpf = cpf.replace('-', '');
      cpf = cpf.split('');

      var v1 = 0;
      var v2 = 0;
      var aux = false;

      for (var i = 1; cpf.length > i; i++) {
        if (cpf[i - 1] != cpf[i]) {
          aux = true;
        }
      }

      if (aux == false) {
        return false;
      }

      for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
        v1 += cpf[i] * p;
      }

      v1 = ((v1 * 10) % 11);

      if (v1 == 10) {
        v1 = 0;
      }

      if (v1 != cpf[9]) {
        return false;
      }

      for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
        v2 += cpf[i] * p;
      }

      v2 = ((v2 * 10) % 11);

      if (v2 == 10) {
        v2 = 0;
      }

      if (v2 != cpf[10]) {
        return false;
      } else {
        return true;
      }
    } else { return false; }
  }


  function consultarLojas(marca: any) {
    const consultarLojasPorMarca = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }



      const resp = await fetch(marcaLojasCarregar.url.replace("{id}", marca.replace(/#/g, "%23")),
        {
          method: marcaLojasCarregar.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      let lojas = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      }
      else {

        if (lojas.Items) {
          setLojas(lojas.Items);
          if (lojas.Items.length == 1) {
            console.log(lojas.Items[0].loja);
            setLoja(lojas.Items[0].loja);
            localStorage.setItem("loja", lojas.Items[0].loja);
            localStorage.setItem("servicoTipoPlural", lojas.Items[0].servicoTipoPlural);
            localStorage.setItem("empresaTelefone", lojas.Items[0].telefone);
          }
          else if (lojas.Items.length == 0) {
            localStorage.removeItem("loja");
            localStorage.removeItem("servicoTipoPlural");
            localStorage.removeItem("empresaTelefone");
          }
          else {
            setShowLojas(true);
          }
        }

      }
    }
    consultarLojasPorMarca();

  }

  function readLojas() {

    if (!chamarServicoMarca) {
      setChamarServicoMarca(true);

      let marca = window.localStorage.getItem("marca") || "";

      if (marca) {
        consultarLojas("marca#" + marca);
      }


    }
    return lojas.map((value: any, index: any, array: any) =>
    (
      <IonSelectOption key={value.loja} value={value.loja}>{value.nome}</IonSelectOption>
    )
    )
  };

  // const handleCheckboxChange = (e: any) => {
  //   const checked = e.target.checked;
  //   setIsEstrangeiro(checked);
  // };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.replace("/primeiroacesso"); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Cadastre-se</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={"Cadastro"}>
        <IonLabel className="titulo">Realize seu cadastro</IonLabel>

        <div className="input">
          <span>Nome</span>
          <IonInput value={nome} maxlength={50} placeholder="" onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
        </div>

        {/* <div className="checkbox-container" hidden={!localStorageIsEstrangeiro}>
          <span>Estrangeiro </span>
          <IonCheckbox checked={isEstrangeiro} onIonChange={handleCheckboxChange} />
        </div> */}

        {/* <div className="input" hidden={isEstrangeiro}>
          <span>CPF</span>
          <IonInput type="tel" maxlength={14} placeholder="___.___.___-__" required value={cpf} onKeyUp={onChangeCPF} />
        </div> */}

        {/* <div className="input" hidden={!isEstrangeiro}>
          <span>Documento</span>
          <IonInput
            type="tel"
            maxlength={11}
            placeholder={"Entre com o documento"}
            required
            value={documento}
            onKeyUp={(e: any) => {
              // Aceita apenas números, removendo caracteres não numéricos
              const onlyNumbers = e.target.value.replace(/\D/g, "");
              setDocumento(onlyNumbers);
            }}
            onIonBlur={() => {
              // Completa com zeros à esquerda se o valor tiver menos de 14 caracteres
              if (documento.length < 11) {
                setDocumento(documento.padStart(11, '0'));
              }
            }}
          />
        </div> */}

        <div className="input">
          <span>Telefone</span>
          <IonInput ref={(ref) => campoTelefone.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefone} onKeyUp={onKeyUpTelefone} />
        </div>
        <div className="input">
          <span>E-mail</span>
          <IonInput value={email} maxlength={50} type="email" placeholder="" onIonInput={(e: any) => setEmail(e.target.value)}></IonInput>
        </div>




        <div className="input" hidden={!showLojas}>

          <span>Loja</span>
          <IonItem lines="none">

            <IonSelect slot="end" value={loja} placeholder="Selecione" onIonChange={e => {
              setLoja(e.detail.value);
              localStorage.setItem("loja", e.detail.value);


              const found = lojas.find((obj: any) => {
                return obj.loja === e.detail.value;
              });

              console.log("found", found);

              if (found) {
                console.log("found", found.servicoTipoPlural);
                localStorage.setItem("servicoTipoPlural", found.servicoTipoPlural);
                localStorage.setItem("empresaTelefone", found.telefone);
              }

            }}>

              {readLojas()}
            </IonSelect>
          </IonItem>
        </div>


        <div className="input" style={{ display: 'block', alignItems: 'center', paddingTop: '30px' }}>
          <IonCheckbox style={{ 'margin-right': '8px' }} checked={checked} onIonChange={e => setChecked(e.detail.checked)} />
          Eu li e aceito os&nbsp;<a style={{ "color": "red" }} target='_blank' href={'https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/cliente' + (window.localStorage.getItem("marca") || '') + '/Termos_de_uso.pdf'}>Termos de Uso <IonIcon src={openOutline} /></a>&nbsp;e&nbsp;<a style={{ "color": "red" }} target='_blank' href={'https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/cliente' + (window.localStorage.getItem("marca") || '') + '/politica_de_privacidade.pdf'}>Política de Privacidade <IonIcon src={openOutline} /></a>
        </div>
        <div hidden={true} className="input" style={{ display: 'block', alignItems: 'center', paddingTop: '30px' }}>
          <IonCheckbox style={{ 'margin-right': '8px' }} checked={checked90diasGratis} onIonChange={e => setChecked90diasGratis(e.detail.checked)} />
          Aceito ter 90 dias grátis
        </div>

        <IonButton onClick={cadastrar}>Cadastrar</IonButton>
        <IonLabel hidden={true} className="jaTem">Já tem uma conta? <Link to="/primeiroacesso">Entrar</Link></IonLabel>
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />
      </IonContent>
    </IonPage>
  );
};

export default Cadastro;
